import * as moment_ from 'moment';
import { Moment } from 'moment';
const moment = moment_;

export function today(): string {
  return moment().toISOString();
}

export function tomorrow(): string {
  return moment(moment()).add(1, 'days').toISOString();
}

export function tomorrowStartOfTheDay(): string {
  return moment(moment()).add(1, 'days').startOf('day').toISOString();
}

export function yesterday(): string {
  return moment(moment()).subtract(1, 'days').toISOString();
}

export function yesterdayStartOfTheDay(): string {
  return moment(moment()).add(1, 'days').startOf('day').toISOString();
}

export function endOfYear(year: number): string {
  return moment([year, 11, 31]).endOf('day').toISOString();
}

export function startOfYear(year: number): string {
    return moment([year, 0, 1]).startOf('day').toISOString();
}

export function addYearsToDate(years: number, date: Date): Moment {
  return moment(date).add(years, 'years');
}

export function currentYear(): number {
  return (new Date()).getFullYear();
}

/**
 * method tests given year for being in interval [currentYear - yearsBack, currentYear]
 * @param year year to test, e.g. 2017
 * @param yearsBack length of years interval that should included tested year to return true, e.g. 3
 */
export function isYearInLastNYears(year: number, yearsBack: number): boolean {
  return year >= currentYear() - yearsBack && year <= currentYear();
}
